<div class="app-chart">
	<div class="header">
		<h5 class="title">
			{{ title }}
		</h5>
		<div class="filters">
			<button *ngIf="showViewAll" class="view-all" (click)="viewAll()">
				{{ labels.viewAll }}
			</button>
			<ng-container *ngFor="let filter of filters">
				<select
					*ngIf="filter.key !== VIEW_ALL_FILTER_KEY"
					class="filter"
					[(ngModel)]="filter.value"
				>
					<option *ngFor="let option of filter.options" [ngValue]="option">
						<a class="{{ filter.value === option ? 'active' : '' }}">
							{{ option.name }}
						</a>
					</option>
				</select>
			</ng-container>
			<span
				*ngIf="!!info"
				[ngbTooltip]="info"
				triggers="click"
				tooltipClass="my-custom-class"
				placement="left"
				class="info-container"
			>
				<span class="info-circle">
					<img src="assets/img/info-ico-card.svg" alt="info" />
				</span>
			</span>
			<button
				class="close"
				type="button"
				aria-label="Close"
				(click)="onClose()"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
	<div class="chart-area">
		<div #chartContainer class="chart-container">
			<canvas #chart></canvas>
		</div>
	</div>
</div>
